"use strict";
var PZCart = function PZCart(props) {
    var downloadimage = props.pzCustomizer.product.promize_customizer_name;
    var pzGenernalSettings = props.generalSettings;
    return React.createElement(
        "div", {
            className: "pz-container"
        },
        React.createElement(
            "div", {
                className: "pz-cart-wrapper"
            },
            React.createElement(
                "div", {
                    className: "pz-product-title-wrapper"
                },
                React.createElement(
                    "h2", {
                        className: "pz-product-title"
                    },
                    React.createElement(
                        "span", {
                            className: "pz-title"
                        },
                        props.pzCustomizer.product.promize_customizer_name
                    )
                )
            ),
            pzGenernalSettings && pzGenernalSettings.length > 0 && pzGenernalSettings.map(function(settings, index) {
                if (settings && settings.settings_type == "common" && settings.promize_settings[0]) {
                    var setting = settings.promize_settings[0];
                    if (setting.reference_id == 9 && setting.reference_name.toLowerCase() == "yes") {
                        return React.createElement(
                            "div", {
                                className: "pz-quantity-container"
                            },
                            React.createElement(
                                "label",
                                null,
                                React.createElement(
                                    "b",
                                    null,
                                    "Qty"
                                ),
                                " "
                            ),
                            React.createElement(
                                "div", {
                                    className: "pz-quantity"
                                },
                                React.createElement(
                                    "button", {
                                        className: "pz-qty-dec",
                                        disabled: props.pzQuantity <= 100 ? "disabled" : '',
                                        onClick: function onClick(e) {
                                            props.pzQuantityHandler(e, props.pzQuantity - 100);
                                        }
                                    },
                                    React.createElement("i", {
                                        className: "fa fa-minus"
                                    })
                                ),
                                React.createElement("input", {
                                    type: "number",
                                    disabled: true,
                                    step: "100",
                                    onChange: function onChange(e) {
                                        props.pzQuantityHandler(e);
                                    },
                                    value: props.pzQuantity,
                                    className: "pz-qty-field",
                                    onBlur: function onBlur(e) {
                                        props.pzQuantityHandler(e, props.pzQuantity ? (props.pzQuantity && props.pzQuantity) < 100 ? 100 : props.pzQuantity : 100);
                                    },
                                    min: 100,
                                    id: "pz-qty-field"
                                }),
                                React.createElement(
                                    "button", {
                                        className: "pz-qty-inc",
                                        onClick: function onClick(e) {
                                            props.pzQuantityHandler(e, props.pzQuantity + 100);
                                        }
                                    },
                                    React.createElement("i", {
                                        className: "fa fa-plus"
                                    })
                                )
                            )
                        );
                    }
                    if (setting.reference_id == 10 && setting.reference_name.toLowerCase() == "yes" && props.pzProductPrice > 0) {
                        ///let pzPrice = parseFloat(props.pzProductPrice * props.pzQuantity) * props.getPrice()
                        var finalPrice = parseFloat(props.getPrice());
                        var pzPrice = parseFloat(finalPrice * parseInt(props.pzQuantity));
                        return React.createElement(
                            "div", {
                                className: "pz-price-container"
                            },
                            React.createElement("input", {
                                type: "hidden",
                                id: "pz_base_price",
                                name: "pz_base_price",
                                value: finalPrice.toLocaleString('en-US', {
                                    minimumFractionDigits: 2
                                })
                            }),
                            React.createElement(
                                "h4", {
                                    className: "pz-price"
                                },
                                "$ ",
                                pzPrice.toLocaleString('en-US', {
                                    minimumFractionDigits: 2
                                }),
                                React.createElement(
                                    "span", {
                                        style: {
                                            fontSize: 12,
                                            fontWeight: 'normal'
                                        }
                                    },
                                    " ($ ",
                                    finalPrice.toLocaleString('en-US', {
                                        minimumFractionDigits: 2
                                    }),
                                    " each)"
                                )
                            )
                        );
                    }
                    if (setting.reference_id == 7 && setting.reference_name.toLowerCase() == "yes") {
                        return React.createElement(
                            "div", {
                                className: "pz-add-to-cart-container"
                            },
                            React.createElement(
                                "button", {
                                    onClick: function onClick(e) {
                                        props.pzAddToCart();
                                    },
                                    className: "pz-btn-cart"
                                },
                                "Add to cart"
                            )
                        );
                    }
                    if (setting.reference_id == 6 && setting.reference_name.toLowerCase() == "yes") {
                        return React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                                "div", {
                                    className: "pz-save-for-later"
                                },
                                React.createElement(
                                    "a", {
                                        id: "download",
                                        download: "" + downloadimage,
                                        href: props.canvasurl
                                    },
                                    React.createElement(
                                        "button", {
                                            className: "pz-btn-save",
                                            onClick: function onClick(e) {
                                                e.preventDefault(), props.pzDownloadHandler();
                                            }
                                        },
                                        React.createElement("i", {
                                            className: "fa fa-download"
                                        }),
                                        React.createElement(
                                            "span",
                                            null,
                                            "Download"
                                        )
                                    )
                                )
                            )
                        );
                    }
                    if (setting.reference_id == 4 && setting.reference_name.toLowerCase() == "yes") {
                        return React.createElement(
                            "div", {
                                className: "pz-share"
                            },
                            React.createElement(
                                "button", {
                                    className: "pz-btn-share",
                                    onClick: function onClick(e) {
                                        e.preventDefault(), props.pzShare();
                                    }
                                },
                                React.createElement("i", {
                                    className: "fa fa-share"
                                }),
                                React.createElement(
                                    "span",
                                    null,
                                    "Share"
                                )
                            )
                        );
                    }
                    if (setting.reference_id == 8 && setting.reference_name.toLowerCase() == "yes") {
                        return React.createElement(
                            "div", {
                                className: "pz-startover"
                            },
                            React.createElement(
                                "button", {
                                    className: "pz-btn-share",
                                    onClick: function onClick(e) {
                                        e.preventDefault(), props.pzStartOverHandler();
                                    }
                                },
                                React.createElement("i", {
                                    className: "fa fa-undo"
                                }),
                                React.createElement(
                                    "span",
                                    null,
                                    "Startover"
                                )
                            )
                        );
                    }
                }
            })
        )
    );
};
